export default {
    quickMsg: function(that,obj){
        if(obj.code==0){
            that.$message.success(obj.msg)
        }else{
            that.$message.error(obj.msg)
        }

    },
    checkLanguage: function () {
        // return "en_US";
        let browserLang = navigator.language
            ? navigator.language
            : navigator.browserLanguage;
        let defaultBrowserLang = "";

        if (browserLang.toLowerCase().indexOf("zh") > -1) {
            defaultBrowserLang = "zh";
        } else {
            defaultBrowserLang = "en";
        }
        return defaultBrowserLang;
    },

    colorMode: function () {
        return "night";
        var h = new Date().getHours();
        if (h > 6 && h <= 18) {
            return "day";
        } else {
            return "night";
        }
    },

    isPc: function () {
        return window.screen.availWidth > 800;
    },

    test() {
        console.log('i like abc')
    },

    // 字符串json化
    // obj : str 或者 obj
    parseJson: function (obj) {
        if (!obj) {
            return
        }
        var data = "";
        if (typeof obj == "object") {
            data = obj;
        } else {
            data = JSON.parse(obj);
        }
        return data;
    },


    // '2018-07-06 15:16:30'
    parseTime: function (timesatmp) {
        var Time = new Date(timesatmp);
        var year = Time.getFullYear();
        var month = (String("0") + (Number(Time.getMonth()) + 1)).substr(-2);
        var day = (String("0") + (Number(Time.getDate()) + 0)).substr(-2);

        var hour = (String("0") + (Number(Time.getHours()) + 0)).substr(-2);
        var min = (String("0") + (Number(Time.getMinutes()) + 0)).substr(-2);
        var sec = (String("0") + (Number(Time.getMinutes()) + 0)).substr(-2);

        var res =
            year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
        return res;
    },

    goName: function (that, name, arg) {
        that.$router.push({ name: name, query: arg })
    },

    goPath: function (that, _path) {
        that.$router.push({ path: _path })
    },

    isObjHasEmpty: function (obj) {
        var res = false
        for (var item in obj) {
            if (!obj[item]) {
                res = true
            }
        }
        return res
    },
    openModal:function(id){
        $('#'+id).modal('toggle')
    }

}